import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import bg3 from "../../assets/images/bg3.jpg";
import logo from "../../assets/images/newlogo.jpg";

import { supabase } from "../../lib/supabaseClient";

import "./css/HomeHero.css";

const HomeHero = () => {
  const [nextEvent, setNextEvent] = useState(null);

  useEffect(() => {
    const loadNextSwarnaprashana = async () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const { data, error } = await supabase
        .from("swarnaprashana_schedule")
        .select("id, date")
        .order("date", { ascending: true });

      if (error) {
        console.error(
          "Error loading Swarnaprashana schedule:",
          error
        );
        return;
      }

      if (!data || data.length === 0) return;

      const next = data.find((item) => {
        const [year, month, day] = item.date.split("-");

        const eventDate = new Date(
          Number(year),
          Number(month) - 1,
          Number(day)
        );

        return eventDate >= today;
      });

      if (!next) return;

      const [year, month, day] = next.date.split("-");

      const eventDate = new Date(
        Number(year),
        Number(month) - 1,
        Number(day)
      );

      setNextEvent({
        date: eventDate.toLocaleDateString("en-IN", {
          day: "numeric",
          month: "long",
        }),
        weekday: eventDate.toLocaleDateString("en-IN", {
          weekday: "long",
        }),
        year,
      });
    };

    loadNextSwarnaprashana();
  }, []);

  return (
    <section
      className="home-hero"
      style={{
        backgroundImage: `url(${bg3})`,
      }}
    >
      {/* =====================================================
          BACKGROUND
      ====================================================== */}

      <div className="home-hero-overlay"></div>

      <div className="hero-glow hero-glow-one"></div>
      <div className="hero-glow hero-glow-two"></div>


      {/* =====================================================
          SWARNAPRASHANA ANNOUNCEMENT
      ====================================================== */}

      {nextEvent && (
        <div className="home-announcement">

          <span className="announcement-dot"></span>

          <span className="announcement-label">
            Next Swarnaprashana
          </span>

          <span className="announcement-date">
            {nextEvent.date} {nextEvent.year}
          </span>

          <span className="announcement-weekday">
            ({nextEvent.weekday})
          </span>

          <Link to="/services">
            View Schedule
            <span>→</span>
          </Link>

        </div>
      )}


      {/* =====================================================
          THREE ZONE HERO
      ====================================================== */}

      <div className="home-container home-hero-content">


        {/* ===================================================
            LEFT ZONE
        ==================================================== */}

        <div className="hero-zone hero-left">

          <div className="hero-left-content">

            <div className="hero-section-label">
              <span></span>
              OUR APPROACH
            </div>

            <h2>
              Rooted in
              <strong>Classical Ayurveda</strong>
            </h2>

            <p className="hero-left-description">
              Personalized Ayurvedic care rooted in classical
              knowledge, thoughtful clinical practice and a
              deeper understanding of the individual.
            </p>


            {/* Small decorative divider */}

            <div className="hero-left-divider">
              <span></span>
              <i>✦</i>
              <span></span>
            </div>


            {/* CTA */}

            <div className="home-hero-buttons">

              <Link
                to="/contact"
                className="home-button home-button-primary"
              >
                Book a Consultation
                <span>→</span>
              </Link>

              <Link
                to="/about"
                className="home-button home-button-outline"
              >
                Meet the Doctor
              </Link>

            </div>

          </div>

        </div>


        {/* ===================================================
            CENTER ZONE — BRAND
        ==================================================== */}

        <div className="hero-zone hero-center">

          <div className="hero-brand">

            {/* Logo */}

            <div className="hero-logo-frame">

              <div className="hero-logo-halo"></div>

              <img
                src={logo}
                alt="Sudhamshu Ayurveda"
                className="hero-clinic-logo"
              />

            </div>


            {/* Sanskrit */}

            <p className="hero-script">
              सुधांशु आयुर्वेद
            </p>


            {/* Clinic Name */}

            <h1>
              Sudhamshu
              <span>Ayurveda</span>
            </h1>


            {/* Divider */}

            <div className="home-hero-divider">

              <span></span>

              <i>✦</i>

              <span></span>

            </div>


            {/* Small brand statement */}

            <p className="hero-brand-statement">
              Tradition · Knowledge · Care
            </p>

          </div>

        </div>


        {/* ===================================================
            RIGHT ZONE
        ==================================================== */}

        <div className="hero-zone hero-right">

          <div className="hero-right-content">

            {/* Decorative visual */}

            <div className="hero-visual">

              <div className="hero-orbit hero-orbit-one"></div>

              <div className="hero-orbit hero-orbit-two"></div>


              <div className="hero-lotus-outline">

                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>

              </div>

            </div>


            {/* Right-side message */}

            <div className="hero-right-text">

              <span className="hero-right-kicker">
                AYURVEDIC WISDOM
              </span>

              <h3>
                A deeper
                <span>understanding of you.</span>
              </h3>

              <p>
                Care that considers the individual,
                not just the condition.
              </p>

            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          LOCATION
      ====================================================== */}

      <div className="hero-location">

        <span></span>

        <span className="location-symbol">✦</span>

        Bengaluru

        <span className="location-symbol">✦</span>

        <span></span>

      </div>

    </section>
  );
};

export default HomeHero;